<mat-nav-list data-testid="admin-nav">
  <mat-list-item>
    <div matLine>{{ (activeGame$ | async)?.Name || 'Causable Admin' }}</div>
  </mat-list-item>
  <hr class="white-text">

  <!-- Task domains -->
  @for (group of domainGroups(); track group.group) {
    <mat-expansion-panel [expanded]="true" [attr.data-testid]="'nav-group-' + group.group">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="margin-right-med">{{ group.icon }}</mat-icon>
          <span>{{ group.group }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      @for (item of group.items; track item.label) {
        <ng-container [ngTemplateOutlet]="navItem" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
      }
    </mat-expansion-panel>
  }

  <hr class="white-text">

  <!-- Footer: home, account, logout -->
  <mat-list-item [routerLink]="['/']" data-testid="nav-home">
    <mat-icon matListItemIcon>home</mat-icon>
    <div matLine>Home</div>
  </mat-list-item>

  @for (group of footerGroups(); track group.group) {
    @for (item of group.items; track item.label) {
      <ng-container [ngTemplateOutlet]="navItem" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
    }
  }

  <mat-list-item data-testid="user-menu-logout-button" (click)="onLogoutClick()">
    <mat-icon matListItemIcon>logout</mat-icon>
    <div matLine>Log out</div>
  </mat-list-item>
</mat-nav-list>

<ng-template #navItem let-item>
  @if (item.externalLink === 'hangfire') {
    @if (hangfireLink) {
      <a [href]="hangfireLink" target="_blank" style="text-decoration: none;">
        <mat-list-item [attr.data-testid]="item.testId">
          <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
          <div matLine>{{ item.label }}</div>
        </mat-list-item>
      </a>
    }
  } @else {
    <mat-list-item [routerLink]="item.routerLink" [attr.data-testid]="item.testId">
      <mat-icon matListItemIcon
                [matBadge]="assignedSupportRequestsCount()"
                matBadgeColor="warn"
                [matBadgeHidden]="item.badge !== 'assignedSupportRequests' || assignedSupportRequestsCount() === 0"
                aria-hidden="false">{{ item.icon }}</mat-icon>
      <div matLine>{{ item.label }}</div>
    </mat-list-item>
  }
</ng-template>
